var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.$root.loading)?_c('div',{staticClass:"loading-gif"},[_c('img',{attrs:{"src":require("@/assets/images/loading.gif")}})]):_vm._e(),(!_vm.$root.loading)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }